<template>
  <div class="bg-gray-50 rounded-lg">
    <!-- Container avec scroll vertical -->
    <div class="h-[400px] overflow-y-auto rounded-lg">
      <table class="min-w-full border border-gray-200 rounded-lg bg-white">
        <thead class="bg-secondary text-white font-bold text-left sticky top-0">
          <tr>
            <th class="px-4 py-2 border-b">Nom</th>
            <th class="px-4 py-2 border-b text-center">Date</th>
            <th class="px-4 py-2 border-b text-right">Montant</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="group in groupedPayments" :key="group.key">
            <!-- Ligne de séparateur du mois -->
            <tr @click="toggleGroup(group.key)" class="cursor-pointer bg-gray-200 select-none">
              <td colspan="3" class="px-4 py-2">
                <div class="flex items-center">
                  <span class="mr-2 font-semibold">
                    {{ getMonthName(group.month) }} {{ group.year }}
                  </span>
                  <span>
                    <i :class="{'fas fa-chevron-up': isGroupOpen(group.key), 'fas fa-chevron-down': !isGroupOpen(group.key)}"></i>
                  </span>
                </div>
              </td>
            </tr>
            <!-- Lignes de paiements pour ce mois -->
            <template v-if="isGroupOpen(group.key)">
              <tr 
                v-for="payment in group.payments" 
                :key="payment.id" 
                class="hover:bg-red-50 even:bg-red-50 odd:bg-white select-none"
                :style="{ backgroundColor: payment.color }"
                @dblclick="perm().cash == 'modification' ? $emit('openPayment', payment) : null"
              >
                <td class="px-4 py-2 border-b border-gray-300 text-left text-gray-700 whitespace-nowrap">
                  {{ payment.name }}
                </td>
                <td class="px-4 py-2 border-b border-gray-300 text-gray-700 whitespace-nowrap">
                  {{ formatDate(payment.date) }}
                </td>
                <td class="px-4 py-2 border-b border-gray-300 text-right text-gray-700 whitespace-nowrap">
                  {{ payment.amount }} €
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
<script>
import { inject } from 'vue';

export default {
  props: {
    payments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // openGroups stocke l'état d'ouverture (true / false) de chaque groupe identifié par une clé (par ex. "2025-4")
      openGroups: {}
    };
  },
  setup() {
    // Injection du store pour accéder aux données globales
    const perm = inject('userPerm');
    return { perm };
  },
  computed: {
    groupedPayments() {
      const groups = {};
      // Regroupe les paiements par année-mois
      this.payments.forEach(payment => {
        const dt = new Date(payment.date);
        // On utilise "année-mois" comme clé
        const key = dt.getFullYear() + '-' + (dt.getMonth() + 1);
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(payment);
      });
      // Convertit l'objet en tableau et trie les groupes
      const result = [];
      for (const key in groups) {
        // Tri des paiements dans le groupe par date
        groups[key].sort((a, b) => new Date(a.date) - new Date(b.date));
        const dt = new Date(groups[key][0].date);
        result.push({
          key,
          month: dt.getMonth(),
          year: dt.getFullYear(),
          payments: groups[key]
        });
      }
      // Tri des groupes par date
      result.sort((a, b) => new Date(a.payments[0].date) - new Date(b.payments[0].date));
      return result;
    }
  },
  methods: {
    toggleGroup(key) {
      // Bascule l'état pour ce groupe
      this.openGroups[key] = !this.isGroupOpen(key);
    },
    isGroupOpen(key) {
      // Par défaut, le groupe est ouvert (true)
      if (this.openGroups[key] === undefined) {
        return true;
      }
      return this.openGroups[key];
    },
    // Retourne le nom du mois à partir de son index
    getMonthName(monthIndex) {
      const monthNames = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
      ];
      return monthNames[monthIndex];
    },
    // Formate la date au format jj/mm/aaaa
    formatDate(dateStr) {
      const [year, month, day] = dateStr.split('-');
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
  
<style scoped>
table {
    border-collapse: separate; /* Nécessaire pour appliquer un border-radius si besoin */
    border-spacing: 0;
}

tbody tr:hover {
    background-color: #ffe0e0 !important; /* ou la couleur que vous souhaitez pour le hover */
}
</style>